export enum WorkflowStateName {
    Initial,
    RegistrationStarted,
    RegistrationSubmitted,
    RegistrationFailed,
    SelfieInstructions,
    Selfie,
    SelfieViewer,
    SelfieUploading,
    VoiceRecording,
    VoiceRecordingUploading,
    VoiceRecordingProcessing,
    VoiceRecordingFailed,
    AvatarFailed,
    UserSaving,
    UserSaveFailed,
    AllSet
}
